import * as _ from "lodash-es";
import { INTEGRATION_LABELS } from "@/dashboard/school/integration/constants";
import { makeOptions } from "@/form-utils";

export default {
  namespaced: true,
  state: {
    staffUsers: {},
    volunteerUsers: {},
    emails: {},
    integrations: {},
    show_regenerate_sid: false,
    has_custom_status: false,
    is_help_reference_editable: false,
    is_help_reference_enabled: false,
    is_template_tags_editable: false,
    is_staff_tfa_enabled: false,
    interview_settings: {},
    favoriteProfiles: {},
    payment_labels: {},
    palette: {},
    is_business_sms_supported: false,
  },
  getters: {
    usersMap: (state) => ({
      ...state.staffUsers,
      ...state.volunteerUsers,
    }),
    integrationServicesOptions: (state) => {
      return makeOptions(
        Object.entries(INTEGRATION_LABELS)
          .filter(([name]) => state.integrations.scheduled_sync_enabled[name])
          .map(([name, label]) => ({
            value: name,
            text: label,
          })),
      );
    },
  },
  mutations: {
    setStaffData(state, data) {
      state.staffUsers = _.keyBy(data.staff_users, "id");
      state.volunteerUsers = _.keyBy(data.volunteer_users, "id");
      state.emails = data.emails;
      state.integrations = data.integrations;
      state.show_regenerate_sid = data.show_regenerate_sid;
      state.has_custom_status = data.has_custom_status;
      state.is_help_reference_enabled = data.is_help_reference_enabled;
      state.is_help_reference_editable = data.is_help_reference_editable;
      state.is_template_tags_editable = data.is_template_tags_editable;
      state.is_staff_tfa_enabled = data.is_staff_tfa_enabled;
      state.interviewSettings = data.interview_settings;
      state.favoriteProfiles = _.zipObject(
        data.user.favorite_profiles,
        data.user.favorite_profiles.map(() => true),
      );
      state.payment_labels = data.payment_labels;
      state.palette = data.palette;
      state.is_business_sms_supported = data.is_business_sms_supported;
    },
    updateIntegrationSettings: function (state, update) {
      state.integrations = { ...state.integrations, ...update };
    },
    updateFavoriteProfiles(state, update) {
      state.favoriteProfiles = {
        ...state.favoriteProfiles,
        ...update,
      };
    },
  },
};
